import React, { useState } from "react";
import { Modal, TextInput, Button, Group } from "@mantine/core";
import config from "config";
import { toast } from "react-toastify";

const FilterRenameModal = ({
  isOpen,
  onClose,
  filterId,
  onRenameSuccess,
  getFilters,
}) => {
  const [newName, setNewName] = useState("");
  const api = config.backOffice.apiName;
  const handleRename = async () => {
    if (!newName.trim()) {
      toast.error("Please enter a valid name for the filter.");
      return;
    }

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/preferences_filters/change_filter_name`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "auth_token_" + api
            )}`, // Remplacez par votre gestion de token
          },
          body: JSON.stringify({ id: filterId.value, name: newName }),
        }
      );

      if (response.ok) {
        onRenameSuccess();

        onClose();
      } else {
        toast.error("Error renaming filter. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while renaming the filter.");
    }
  };

  return (
    <Modal opened={isOpen} onClose={onClose} title="Rename Filter" centered>
      <TextInput
        label="New Filter Name"
        placeholder="Enter new filter name"
        value={newName}
        onChange={(event) => setNewName(event.currentTarget.value)}
        required
      />
      <Group position="right" mt="md">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleRename}>Rename</Button>
      </Group>
    </Modal>
  );
};

export default FilterRenameModal;
